import React from 'react';
import { affiliations } from '../data';

const colorMap: Record<string, string> = {
  blue: 'rgba(74,144,226,0.15)',
  green: 'rgba(34,197,94,0.15)',
  orange: 'rgba(249,115,22,0.15)',
  purple: 'rgba(168,85,247,0.15)',
  red: 'rgba(239,68,68,0.15)',
  teal: 'rgba(20,184,166,0.15)',
};

export default function Affiliations() {
  return (
    <section id="affiliations" className="py-24 md:py-32 relative" style={{background:'#0A0A14'}}>
      <div className="grid-bg absolute inset-0 opacity-30" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-16 reveal">
          <span className="section-tag">Recognized & Certified</span>
          <h2 className="font-playfair font-black text-white mb-4" style={{fontFamily:'Playfair Display,serif',fontSize:'clamp(2rem,3.5vw,3rem)'}}>
            Our <span style={{color:'#C8A84B'}}>Affiliations</span> & Recognition
          </h2>
          <p style={{color:'rgba(212,207,197,0.6)',maxWidth:'540px',margin:'0 auto',fontSize:'0.9rem',lineHeight:'1.7'}}>
            ITS Academy is a government-recognized, NIELIT-affiliated institute. Our certifications are validated by national bodies and valued by employers across India.
          </p>
        </div>

        {/* Affiliation logos grid */}
       <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mb-16">
  {[1,2,3,4,5,6,7,8].map(n => (
    <div
      key={n}
      className="cert-card p-4 flex items-center justify-center hover-lift"
      style={{ height: "120px" }}
    >
      <img
        src={`/images/logos/logo${n}.png`}
        alt={`Affiliation ${n}`}
        className="max-h-[80px] w-auto object-contain"
      />
    </div>
  ))}
</div>

        {/* Affiliation cards */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {affiliations.map((aff, i) => (
            <div key={i} className="reveal hover-lift p-6 rounded-sm border transition-all duration-300 group"
              style={{background:colorMap[aff.color] || 'rgba(200,168,75,0.05)',border:'1px solid rgba(200,168,75,0.12)',animationDelay:`${i*0.1}s`}}>
              <div className="flex items-center gap-4 mb-4">
                <div className="w-12 h-12 rounded-sm overflow-hidden flex-shrink-0" style={{border:'1px solid rgba(200,168,75,0.2)'}}>
                  <div className="img-placeholder w-full h-full">
                    <span className="text-xl">🏛️</span>
                  </div>
                </div>
                <div>
                  <div className="text-white font-bold">{aff.name}</div>
                  <div style={{color:'rgba(212,207,197,0.45)',fontSize:'0.72rem'}}>{aff.fullName}</div>
                </div>
              </div>
              <p style={{color:'rgba(212,207,197,0.6)',fontSize:'0.82rem',lineHeight:'1.7'}}>{aff.desc}</p>
            </div>
          ))}
        </div>

        {/* Why it matters */}
        <div className="reveal mt-16 grid md:grid-cols-4 gap-4">
          {[
            { icon: '🏆', title: 'Credibility', desc: 'Certificates recognized by government & industry' },
            { icon: '💼', title: 'Employability', desc: 'Better job opportunities in IT, hardware & software' },
            { icon: '📈', title: 'Growth', desc: 'Skills aligned with current market requirements' },
            { icon: '✅', title: 'Trust', desc: 'Assurance of quality education from certified institute' },
          ].map((item, i) => (
            <div key={i} className="text-center p-6 rounded-sm" style={{background:'rgba(200,168,75,0.04)',border:'1px solid rgba(200,168,75,0.1)'}}>
              <div className="text-3xl mb-3">{item.icon}</div>
              <div className="text-white font-bold mb-2">{item.title}</div>
              <div style={{color:'rgba(212,207,197,0.5)',fontSize:'0.8rem',lineHeight:'1.6'}}>{item.desc}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
